import http from '@/support/services/HttpService';

class ProfileRequest {
  static save(payload) {
    return http.patch('v1/administradores/alterarSenha', payload);
  }
}

export default ProfileRequest;
